import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppShell from "./components/AppShell";

import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import AuthCallback from "./pages/AuthCallback";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import Dashboard from "./pages/Dashboard";
import Tryouts from "./pages/Tryouts";
import Modules from "./pages/Modules";
import Arena from "./pages/Arena";
import MegaTryout from "./pages/MegaTryout";
import Drills from "./pages/Drills";
import Guilds from "./pages/Guilds";
import Referral from "./pages/Referral";
import Missions from "./pages/Missions";
import Feedback from "./pages/Feedback";
import CBTSimulator from "./pages/CBTSimulator";
import Result from "./pages/Result";
import Leaderboard from "./pages/Leaderboard";
import Pricing from "./pages/Pricing";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import LocalCheckout from "./pages/LocalCheckout";
import Transactions from "./pages/Transactions";
import Terms from "./pages/Terms";
import FAQ from "./pages/FAQ";
import Refund from "./pages/Refund";
import Contact from "./pages/Contact";
import TentangKami from "./pages/TentangKami";
import Fitur from "./pages/Fitur";
import Paket from "./pages/Paket";
import TestimoniPage from "./pages/TestimoniPage";
import MyTestimonial from "./pages/MyTestimonial";
import AdaptivePractice from "./pages/AdaptivePractice";
import PaymentResult from "./pages/PaymentResult";
import WhatsAppFab from "./components/WhatsAppFab";
import Admin from "./pages/Admin";

const shell = (el) => (
  <ProtectedRoute>
    <AppShell>{el}</AppShell>
  </ProtectedRoute>
);

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/refund" element={<Refund />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/tentang" element={<TentangKami />} />
      <Route path="/fitur" element={<Fitur />} />
      <Route path="/paket" element={<Paket />} />
      <Route path="/testimoni" element={<TestimoniPage />} />
      <Route path="/payment/result" element={<PaymentResult />} />
      <Route path="/dashboard" element={shell(<Dashboard />)} />
      <Route path="/tryouts" element={shell(<Tryouts />)} />
      <Route path="/modules" element={shell(<Modules />)} />
      <Route path="/arena" element={shell(<Arena />)} />
      <Route path="/mega" element={shell(<MegaTryout />)} />
      <Route path="/drills" element={shell(<Drills />)} />
      <Route path="/guilds" element={shell(<Guilds />)} />
      <Route path="/referral" element={shell(<Referral />)} />
      <Route path="/missions" element={shell(<Missions />)} />
      <Route path="/feedback" element={shell(<Feedback />)} />
      <Route path="/testimoni-saya" element={shell(<MyTestimonial />)} />
      <Route path="/adaptive" element={shell(<AdaptivePractice />)} />
      <Route path="/cbt/:attemptId" element={<ProtectedRoute><CBTSimulator /></ProtectedRoute>} />
      <Route path="/result/:attemptId" element={shell(<Result />)} />
      <Route path="/leaderboard" element={shell(<Leaderboard />)} />
      <Route path="/pricing" element={shell(<Pricing />)} />
      <Route path="/transactions" element={shell(<Transactions />)} />
      <Route path="/payment/local" element={<ProtectedRoute><AppShell><LocalCheckout /></AppShell></ProtectedRoute>} />
      <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
      <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute admin><AppShell><Admin /></AppShell></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  useEffect(() => { document.title = "SkorUp.io — Level Up Skor SNBT & CPNS"; }, []);
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <WhatsAppFab />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
